import {valOrEval} from './functional';
import {easings, DEFAULT_SMOOTH_SCROLL_DURATION} from './anim';

export function smoothScrollTo (to, duration, easing) {
  if(_scrollLocker.active) {
    return;
  }
  var animState = {
    easing: easings.getEasing(easing),
    duration: duration || DEFAULT_SMOOTH_SCROLL_DURATION,
    end: to,
    start: {
      x: window.pageXOffset,
      y: window.pageYOffset,
    }
  };


  function abortHandler() {
    // for aborting in case of user-requested manual scroll
    // cancel animation
    window.cancelAnimationFrame(animState.nextFrame);
    // skip to the end
    var finalPosition = valOrEval(animState.end);
    window.scrollTo(finalPosition.x, finalPosition.y);
    // remove self
    window.removeEventListener('wheel', abortHandler);
    window.removeEventListener('touchstart', abortHandler);
  }

  window.addEventListener('wheel', abortHandler);
  window.addEventListener('touchstart', abortHandler);

  function rafHandler (ts){
    if (!animState.t) {
      animState.t = {
        start: ts,
        end: ts + animState.duration,
      };
    }
    animState.t.current = Math.min(
      ts - animState.t.start, animState.duration);

    window.scrollTo(
      animState.easing(
        animState.t.current,
        animState.start.x,
        valOrEval(animState.end).x - animState.start.x,
        animState.duration),
      animState.easing(
        animState.t.current,
        animState.start.y,
        valOrEval(animState.end).y - animState.start.y,
        animState.duration)
    );
    if (animState.t.current < animState.duration) {
      animState.nextFrame = window.requestAnimationFrame(rafHandler);
    }
  }
  animState.nextFrame = window.requestAnimationFrame(rafHandler);
};

export function smoothScrollBy(by, duration, easing) {
  var init = {x: window.pageXOffset, y: window.pageYOffset};
  this.smoothScrollTo(
    function() {
      return {
        x: valOrEval(by).x + init.x,
        y: valOrEval(by).y + init.y
      };
    }, duration, easing);
};

export function smoothScrollIntoView(element, duration, easing) {
  this.smoothScrollTo(function(){
    var pos = element.getBoundingClientRect();
    var scroll = {x: window.pageXOffset, y: window.pageYOffset};
    return {
      x: scroll.x + pos.left,
      y: scroll.y + pos.top
    };
  }, duration, easing);
};

function _scrollLocker(ev) {
  ev.preventDefault();
  ev.returnValue = false;
  return false;
};

export function lockScrolling() {
  if(_scrollLocker.active ) {
    return;
  }
  _scrollLocker.active = true;
  window.addEventListener('scroll', _scrollLocker);
  window.addEventListener('mousewheel', _scrollLocker);
  window.addEventListener('wheel', _scrollLocker);
  window.addEventListener('DOMMouseScroll', _scrollLocker);
};

export function unlockScrolling() {
  if(!_scrollLocker.active ) {
    return;
  }
  window.removeEventListener('scroll', _scrollLocker);
  window.removeEventListener('mousewheel', _scrollLocker);
  window.removeEventListener('wheel', _scrollLocker);
  window.removeEventListener('DOMMouseScroll', _scrollLocker);
  _scrollLocker.active = false;
};



// WEBPACK FOOTER //
// ./lib/rlink-utils/scrolling.js